import { Link } from 'react-router-dom'
import {
  BadgeDollarSign,
  Bot,
  Clock3,
  Megaphone,
  Rocket,
  TrendingUp,
  Users,
} from 'lucide-react'

const reports = [
  {
    title: 'Entrada de leads',
    description: 'Novos contatos recebidos por dia.',
    path: '/relatorios/entrada-leads',
    icon: Users,
  },
  {
    title: 'Vendas e perdas',
    description: 'Vendas, receita e motivos de perda.',
    path: '/relatorios/vendas',
    icon: BadgeDollarSign,
  },
  {
    title: 'Vendas por vendedor',
    description: 'Funil, conversão e ticket por vendedor.',
    path: '/relatorios/vendas-vendedor',
    icon: TrendingUp,
  },
  {
    title: 'Tempo de resposta',
    description: 'Velocidade das respostas humanas por vendedor.',
    path: '/relatorios/tempo-resposta',
    icon: Clock3,
  },
  {
    title: 'Vendas por campanha',
    description: 'Receita da coorte por primeiro toque.',
    path: '/relatorios/vendas-campanha',
    icon: Megaphone,
  },
  {
    title: 'Performance de Marketing',
    description: 'Leads de anúncios (CTWA) até a venda, por criativo.',
    path: '/relatorios/performance-marketing',
    icon: Rocket,
  },
  {
    title: 'Agendamentos da IA',
    description: 'Eventos criados pela IA no Google Calendar.',
    path: '/relatorios/agendamentos-ia',
    icon: Bot,
  },
]

export default function Relatorios() {
  return (
    <div className="flex w-full flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground sm:text-3xl">Relatórios</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Acompanhe aquisição, vendas, atendimento e agendamentos.
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {reports.map((report) => {
          const Icon = report.icon
          return (
            <Link
              key={report.path}
              to={report.path}
              className="group rounded-xl border border-border bg-card p-5 transition-colors hover:bg-hover"
            >
              <Icon className="h-6 w-6 text-primary" />
              <h2 className="mt-4 font-semibold text-foreground">{report.title}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{report.description}</p>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
